import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import "./css/Gallery.css";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
const galleryImages = [
  { title: "Masai Mara Safari", src: require("../assets/image/8.jpg") },
  { title: "Diani Beach Kenya", src: require("../assets/image/30.jpg") },
  { title: "Diani Beach Sunrise", src: require("../assets/image/31.jpg") },
  { title: "Lake Naivasha Wildlife", src: require("../assets/image/32.jpg") },
  { title: "Nairobi City Safari View", src: require("../assets/image/33.jpg") },
  { title: "Tsavo National Park Safari", src: require("../assets/image/34.jpg") },
  { title: "Masai Mara Game Drive", src: require("../assets/image/35.jpg") },
  { title: "Diani Beach Resort", src: require("../assets/image/36.jpg") },
  { title: "Diani Beach Sunset", src: require("../assets/image/37.jpg") },
  { title: "Lake Naivasha Birds", src: require("../assets/image/3.jpg") },
  { title: "Nairobi City Night View", src: require("../assets/image/17.jpg") },
  { title: "Tsavo Elephant Safari", src: require("../assets/image/18.jpg") },
  { title: "Masai Mara Big Five", src: require("../assets/image/39.jpg") },
  { title: "Diani Beach Paradise", src: require("../assets/image/40.jpg") },
  { title: "Diani Beach Palm Trees", src: require("../assets/image/41.jpg") },
  { title: "Lake Naivasha Safari Boat", src: require("../assets/image/48.jpg") },
  { title: "Nairobi City Aerial View", src: require("../assets/image/43.jpg") },
  { title: "Tsavo Lion Safari", src: require("../assets/image/44.jpg") },
  { title: "Masai Mara Adventure", src: require("../assets/image/45.jpg") },
  { title: "Diani Beach Holidays", src: require("../assets/image/46.jpg") },
  { title: "Diani Beach Relaxation", src: require("../assets/image/47.jpg") },
  { title: "Lake Naivasha Safari Views", src: require("../assets/image/53.jpg") },
  { title: "Nairobi City Daylife", src: require("../assets/image/52.jpg") },
  { title: "Tsavo Safari Adventures", src: require("../assets/image/50.jpg") }
];

const Gallery = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxOpen) return;
      if (e.key === "Escape") setLightboxOpen(false);
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  });

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const nextImage = () =>
    setCurrentIndex((prev) => (prev + 1) % galleryImages.length);

  const prevImage = () =>
    setCurrentIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);

  return (
    <>
      <SEO
        title="Safari Photo Gallery | Joujo Safaris"
        description="Discover Joujo Safaris gallery featuring the Masai Mara, Diani Beach, Lake Naivasha, Nairobi City, and Tsavo National Park. Explore Africa's beauty through our safari photography."
        url="https://joujosafaris.com/gallery"
        image="https://www.joujosafaris.com/static/media/32.67129368ad4a6a05e1af.jpg"
        keywords="Kenya safari gallery, Masai Mara photos, Diani Beach images, Tsavo safari pictures, Lake Naivasha photography, Nairobi City safari"
      />

      {/* ✅ JSON-LD for Image Gallery */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ImageGallery",
          "name": "Safari Photo Gallery | Joujo Safaris",
          "url": "https://joujosafaris.com/gallery",
          "description":
            "Browse stunning safari photography from Joujo Safaris featuring Kenya’s top destinations including Masai Mara, Diani Beach, Lake Naivasha, Tsavo National Park, and Nairobi.",
          "publisher": {
            "@type": "Organization",
            "name": "Joujo Safaris",
            "url": "https://joujosafaris.com",
            "sameAs": [
              "https://x.com/SafarisJoujo",
              "https://www.facebook.com/J0ujosafaris/",
              "https://www.instagram.com/joujo_safaris/"
            ]
          },
          "image": galleryImages.map((img) => ({
            "@type": "ImageObject",
            "url": `https://joujosafaris.com/assets/${img.title
              .toLowerCase()
              .replace(/ /g, "-")}.jpg`,
            "caption": img.title
          }))
        })}
      </script>

      <Navbar />
      <div className="container">
        <section className="about-hero">
          <div className="about-hero-container">
            <div className="about-text">
              <div className="about-sub-title">
                <h4 className="text-color">Join Us</h4>
                <h5>Our Safari Journal</h5>
              </div>
              <p>
                Joujo Safaris, part of Join Us Joiners, is dedicated to creating unforgettable adventures 
                while promoting wildlife conservation and authentic cultural encounters.
              </p>
            </div>

            <div className="gallery-image">
              <img
                src={require("../assets/image/naivasha_trip_couple_kenya.png")}
                alt="Couple Safari at Lake Naivasha with Joujo Safaris"
              />
            </div>
          </div>
        </section>

        <section className="gallery-section container">
          <div className="home-title">
            <h2>Photo Gallery</h2>
            <p>Experience Africa’s Beauty</p>
          </div>
          <div className="gallery-grid">
            {galleryImages.map((img, index) => (
              <div
                key={index}
                className="gallery-item"
                onClick={() => openLightbox(index)}
              >
                <LazyLoadImage
                  alt={img.title}
                  src={img.src}
                  effect="blur"
                />
                <div className="gallery-overlay">
                  <span>{img.title}</span>
                </div>
              </div>
            ))}
          </div>

          {lightboxOpen && (
            <div className="lightbox">
              <button className="close-btn" onClick={closeLightbox}>
                &times;
              </button>
              <button className="prev-btn" onClick={prevImage}>
                &#10094;
              </button>
              <img
                  src={galleryImages[currentIndex].src}
                alt={galleryImages[currentIndex].title}
                  effect="blur"
                />
              <button className="next-btn" onClick={nextImage}>
                &#10095;
              </button>
              <div className="lightbox-caption">
                {galleryImages[currentIndex].title}
              </div>
            </div>
          )}
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Gallery;
